export default "__VITE_ASSET__vshZnCfq__"